/** auditLog: toda acción de admin y toda transición de pedido (sección 7). Solo lectura. */
import { useEffect, useState, type ReactElement } from 'react';
import { collection, getDocs, limit, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase.js';
import { muted, Table, td, when, str } from '../lib/ui.js';

type Doc = Record<string, unknown>;

export function AuditPage(): ReactElement {
  const [rows, setRows] = useState<Doc[] | null>(null);
  useEffect(() => {
    getDocs(query(collection(db, 'auditLog'), orderBy('at', 'desc'), limit(200)))
      .then((s) => {
        setRows(s.docs.map((d) => ({ id: d.id, ...d.data() })));
      })
      .catch(() => {
        setRows([]);
      });
  }, []);
  return (
    <>
      <h1 style={{ margin: 0 }}>Auditoría</h1>
      {!rows && <p style={muted}>Cargando…</p>}
      {rows && (
        <Table head={['Cuándo', 'Acción', 'Objetivo', 'Actor', 'Motivo', 'Después']}>
          {rows.map((r) => (
            <tr key={String(r.id)}>
              <td style={td}>{when(r.at)}</td>
              <td style={td}>{String(r.action)}</td>
              <td style={td}>
                {String((r.target as Doc | undefined)?.collection)}/
                {String((r.target as Doc | undefined)?.id)}
              </td>
              <td style={td}>{JSON.stringify(r.actor)}</td>
              <td style={td}>{typeof r.reason === 'string' ? r.reason : ''}</td>
              <td style={td}>
                <code style={{ fontSize: 11 }}>{str(r.after).slice(0, 160)}</code>
              </td>
            </tr>
          ))}
        </Table>
      )}
    </>
  );
}
